import {configureStore} from '@reduxjs/toolkit'
import userAccountReducer from "../features/userAccountSlice";
import taxonomyBatchReducer from '../features/taxonomyBatchSlice';
import npiBatchReducer from '../features/npiBatchSlice';
import validationRuleReducer from '../features/validationRuleSlice';
import allHispsReducer from '../features/allHispsSlice'
import servDescriptionReducer from "../features/servDescriptionBatchSlice";
import allBatchesReducer from "../features/allBatchesSlice";
import currentDirectFhirInformationReducer from "../features/currentDirectoryFhirInformationSlice";

const store = configureStore({
    reducer: {
        userAccount: userAccountReducer,
        taxonomyBatch: taxonomyBatchReducer,
        npiBatch: npiBatchReducer,
        validationRules: validationRuleReducer,
        allHisps: allHispsReducer,
        servDescriptionBatch: servDescriptionReducer,
        allBatches: allBatchesReducer,
        currentDirectFhirInformation: currentDirectFhirInformationReducer
    },
    // Disable Redux devTools
    // devTools: false,
})

export default store;